import { DatabaseRecord } from "../repos/table.repo";

export interface ElectronicContractModel extends DatabaseRecord {
    waterUserCode?: string;
    waterUserId?: string;
    waterFactoryId?: string;
    templateId?: string;
    documentId?: string;
    documentCode?: string;
    matBaoCATemplateId?: string;
    status?: string;
    viewUrl?: string;
    signedPdfPath?: string;
    errorMessage?: string;
    createdAt?: string;
    otpSentAt?: string;
    signedAt?: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    customerName?: string;
    customerCode?: string;
    customerPhone?: string;
    customerEmail?: string;
}

export interface CreateElectronicContractModel {
    waterUserCode: string;
    templateId?: string;
}

export interface ViewDocumentModel {
    electronicContractId: string;
    type?: number;
}

export interface SendOtpModel {
    electronicContractId: string;
    otpType: number;
    deviceOTP: string;
}

export interface SignDocumentModel {
    electronicContractId: string;
    otpType: number;
    deviceOTP: string;
    codeOTP: string;
    signatureCustomerImage64?: string;
}



export class ElectronicContractModelFactory {
    static getEmpty(): ElectronicContractModel {
        return {
            id: "",
            waterUserCode: "",
            waterUserId: "",
            waterFactoryId: "",
            templateId: "",
            documentId: "",
            documentCode: "",
            matBaoCATemplateId: "",
            status: "",
            viewUrl: "",
            signedPdfPath: "",
            errorMessage: "",
            createdAt: "",
            otpSentAt: "",
            signedAt: "",
            createdBy: "",
            updatedAt: "",
            updatedBy: "",
            customerName: "",
            customerCode: "",
            customerPhone: "",
            customerEmail: ""
        };
    }
}

export class CreateElectronicContractModelFactory {
    static getEmpty(): CreateElectronicContractModel {
        return {
            waterUserCode: "",
            templateId: ""
        };
    }
}
